import { createContext, useContext } from 'react';
import { LocalizationContextType } from '@/types/i18n';

export const LocalizationContext = createContext<LocalizationContextType | undefined>(undefined);

export function useLocalizationContext(): LocalizationContextType {
  const context = useContext(LocalizationContext);
  
  if (!context) {
    throw new Error('useLocalizationContext must be used within a LocalizationProvider');
  }
  
  return context;
}
